import React, { useEffect, useRef, useState } from 'react';
import './registry.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import moment from 'moment/moment';
import {
  calculatedViewMode,
  getFilterData,
  getPaginationOpts,
  getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getRegisterData } from '../reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import SZLTView from './SZLTView';
import {
  loadSZLTById,
  loadSZLTList,
  loadSZLTFieldsValidation, extractSZLTById,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import {
  REGISTRIES_STATUS_LIST,
} from '../../../configs';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { additionalSzltColumns, szltColumns } from './szltColumns';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import ViewDocument from '../../System/components/ViewDocument';
import ExportInterface from '../../System/components/ExportInterface';

export default function SZLTRegistryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { updatePeriod } = useSelector(getSystemData);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showExtract, setShowExtract] = useState(false);
  const registry_id = searchParams.get('registry_id');
  const numbersText = searchParams.get('numbers') || '';
  const numbers = numbersText.split(',') || [];
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    // created_at_from: defaultDate[0],
    // created_at_to: defaultDate[1],
    view_mode: 2,
    numbers,
  };

  const filterName = 'szlt-filter';
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: defaultFilterValues,
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });

  const {
    loadingSzltList,
    szltList = [],
    szltListMeta = {},
    currentSZLT = {},
    loadingCurrentSZLT = false,
    szltFieldsValidation = {},
    loadingSzltExtractList,
    szltExtractList,
  } = useSelector(getRegisterData);

  const loadRegistry = () => {
    if (registry_id) {
      dispatch(loadSZLTById(registry_id))
        .then(() => {
          setShowView(true);
          dispatch(loadSZLTFieldsValidation({ id: registry_id })).catch(responseLogWithNotification);
        })
        .catch(response => errorNotification('Загрузка реестровых данных', getResponseError(response)));
    }
  };
  const loadData = opts => {
    const filterData = getValues();
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].szltListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData, ...viewModeData },
      sort,
    };
    const p1 = dispatch(loadSZLTList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [sort, setSort] = useState(getDefaultSort(szltColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);

  useEffect(loadRegistry, [registry_id]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem(filterName, JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    setSearchParams({ registry_id: item.id });
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClose = item => {
    setSearchParams({});
    setShowExtract(false);
  };

  const handleExtract = item => event => {
    if (!item) {
      return;
    }

    dispatch(extractSZLTById({ id: item.id }))
      .then(() => {
        successNotification('Выписка', 'Выписка прошла успешно');
      })
      .catch(response => errorNotification('Выписка', getResponseError(response)));

    setShowExtract(true);
    setSelectedRow(item);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
            Просмотреть
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={handleExtract(item)}>
            Выписка
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    const ed = moment(item.expiration_date);
    const now = moment();
    if (ed.isValid() && now.diff(ed, 'days') >= 0) {
      classes.push('expiration');
    }
    if (item && item.archived_at) {
      classes.push('is_archive');
    }
    return classes.join(' ');
  };

  return (
    <div className="page application-page">
      <Loader
        global
        loading={loadingSzltList || loadingCurrentSZLT || loadingSzltExtractList}
      />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.region.registry.szlt' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            className="no-border"
            options={REGISTRIES_STATUS_LIST}
            placeholder="Статус"
            addPlaceholder
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.created_at}
            usePortal
            placeholder="Дата"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
          <div className="filter-sep" />
          <ExportInterface page="order_services" exporter="order_services" getValues={getValues} />
          <div className="filter-sep" />
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          ><Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={defaultFilterValues}
                page={PAGE_TYPE.SZLT}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                rowClassFormatter={rowClassFormatter}
                data={szltList}
                changeSort={changeSort}
                sort={sort}
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                columns={szltColumns}
                additionalColumns={additionalSzltColumns}
                name="szlt-list"
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={szltListMeta} list={szltList} handleChangeMeta={loadData} />
        </div>
      </div>
      {showView && currentSZLT ? <SZLTView formMeta={szltFieldsValidation} onClose={() => { handleClose(); setShowView(false); }} loadData={loadData} /> : null}
      {showExtract && szltExtractList
        ? (
          <ViewDocument
            loadData={loadData}
            handleClose={handleClose}
            loadingSzltExtractList={loadingSzltExtractList}
            document={{ files: [szltExtractList] }}
            prevCrumbs={(
              <>
                <span className="breadcrumbs-prev">Реестры</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
                <span className="breadcrumbs-prev">Реестр СЗЛТ</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
                  )}
          />
        ) : null}
    </div>
  );
}
